import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { getCachedSignedUrl } from '@mcn-platform/models';
import AudioPlayer from '../CustomizedPlayer/AudioPlayer';
/**
 * Implements a preview of an Audio.
 * It is a key frame.  For other types it might be an icon or something similar.
 * @param bucket s3 bucket name where audio stored
 * @param path asset path(key/name) of audio file in s3 bucket
 * @returns JSX component
 */
const SignedAudioPlayer = ({ bucket, path, ...otherProps }) => {
    const [url, setUrl] = useState();
    // console.log(`Rendering with bucket ${bucket} and key ${path}`);
    useEffect(() => {
        if (!bucket || !path) {
            return;
        }
        getCachedSignedUrl(bucket, path).then((val) => {
            console.log('setting audio url to', val);
            setUrl(val);
        });
    }, [bucket, path]);
    if (!url) {
        return (_jsx("div", { children: "Loading..." }));
    }
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    _jsx(AudioPlayer, { url: url, ...otherProps }));
};
export default observer(SignedAudioPlayer);
//# sourceMappingURL=SignedAudioPlayer.js.map